import { CheckCircleRounded } from "@mui/icons-material";
import { Avatar, Badge, Card, CardContent, Rating, styled, Typography } from "@mui/material";
import { Box, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../store/tokens";
import "./FreelancerItem.css";

const truncate = (str, len) => (str && str.length > len ? str.slice(0, len) + "…" : str);

const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    right: 14,
    top: 62,
    border: `3px solid ${tokens.color.white}`,
    padding: "5px",
    borderRadius: "50%",
  },
}));

const FreelancerItemNew = (props) => {
  const navigate = useNavigate();
  const { freelancerData } = props;
  const {
    category,
    active_state,
    name,
    pic,
    sopnoId,
    sub_category,
    user_rate,
    user_state,
    user_skill,
  } = freelancerData;

  // NOTE: user_rate is an object ({average_rating, total_review, ...}), not
  // a plain number — this file previously treated it as one in several
  // places, including rendering the whole object directly as a child
  // (`{user_rate}`), which crashed with "Objects are not valid as a React
  // child". Every usage below now drills into the specific field it needs.
  const averageRating = user_rate?.average_rating ?? 0;
  const totalReviews = user_rate?.total_review ?? 0;
  const isActive = active_state?.[0]?.state === 1;
  const isVerified = user_state === 1;

  return (
    <Card
      onClick={() => navigate("/" + sopnoId)}
      sx={{
        cursor: "pointer",
        borderRadius: `${tokens.radius.lg}px`,
        border: `1px solid ${tokens.color.line}`,
        overflow: "hidden",
        transition: "box-shadow 0.25s ease, transform 0.25s ease",
        "&:hover": {
          boxShadow: tokens.shadow.md,
          transform: "translateY(-3px)",
        },
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(to right, ${tokens.color.teal}, ${tokens.color.tealDark})`,
          width: "100%",
          height: 72,
        }}
      />

      <CardContent sx={{ mt: "-48px", pb: 2.5 }}>
        <Stack spacing={2} justifyContent="left" alignItems="center">
          <StyledBadge
            overlap="circular"
            variant="dot"
            color={isActive ? "success" : "default"}
          >
            <Avatar
              alt={name ?? "Freelancer"}
              src={pic || "https://aps.songjukti.com/image/web_admin/data_entry.jpg"}
              sx={{ width: 80, height: 80, border: `4px solid ${tokens.color.white}` }}
            />
          </StyledBadge>

          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Box>
              <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                <CheckCircleRounded
                  sx={{
                    fontSize: "1.05rem",
                    color: isVerified ? tokens.color.success : tokens.color.inkFaint,
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: tokens.font.heading,
                    textAlign: "center",
                    fontSize: "1rem",
                    fontWeight: 700,
                    color: tokens.textOn.light.primary,
                  }}
                >
                  {name ?? "-"}
                </Typography>
              </Stack>
              <Typography
                sx={{
                  fontFamily: tokens.font.body,
                  textAlign: "center",
                  fontSize: "0.85rem",
                  color: tokens.textOn.light.secondary,
                  mt: 0.25,
                }}
              >
                {user_skill ? user_skill : [category, sub_category].filter(Boolean).join(", ")}
              </Typography>
            </Box>

            <Stack spacing={0.5} direction="row" justifyContent="center" alignItems="center">
              <Typography
                sx={{
                  fontFamily: tokens.font.body,
                  fontSize: { xs: "0.7rem", md: "0.8rem" },
                  fontWeight: 700,
                  color: tokens.color.ink,
                  bgcolor: tokens.color.warningBg,
                  px: 0.75,
                  py: 0.25,
                  borderRadius: `${tokens.radius.sm}px`,
                }}
              >
                {averageRating.toFixed(1)}
              </Typography>
              <Rating name="read-only" value={averageRating} readOnly precision={0.5} sx={{ fontSize: "1rem" }} />
              <Typography
                sx={{
                  fontFamily: tokens.font.body,
                  fontSize: { xs: "0.7rem", md: "0.8rem" },
                  fontWeight: 600,
                  color: tokens.textOn.light.secondary,
                }}
              >
                ({totalReviews} reviews)
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default FreelancerItemNew;